import { AssetCategoryApi, AssetApi } from "@kdmanalytics/brm-system";
import BrmApiClient from "services/brm/BrmApiClient";

export const assetCategoryApi = new AssetCategoryApi(BrmApiClient.instance);
export const assetApi = new AssetApi(BrmApiClient.instance);
